const SEARCH_MAPI_COMPLETED = 'frontend-shell:search-mapi-completed';
const SEARCH_MAPI_COMPLETED_WITH_ERROR = 'frontend-shell:search-mapi-completed-with-error';
export default ({
  AB,
  trigger,
  fetcher,
  getMapiLandingPage,
  metaURL,
  setSessionStorageKey
}) => {
  const searchMapiCompleted = data => {
    if (!data.errors && getMapiLandingPage() !== 'RESULT') {
      trigger(SEARCH_MAPI_COMPLETED, {
        ...data,
        errors: null
      });
      return {
        redirect: true
      };
    }
    if (data.errors) {
      handlerSearchMapiError();
    }
    setSessionStorageKey('repricingMAPI', undefined);
    return {
      redirect: false
    };
  };
  const handlerSearchMapiError = () => {
    trigger(SEARCH_MAPI_COMPLETED_WITH_ERROR);
  };
  const handlerCreateMapiShoppingCart = async ({
    search
  }) => {
    if (AB.isFecoCheckoutPassengers) {
      return {
        redirect: false
      };
    }
    if (AB.isPreCreateShoppingCartMeta || getMapiLandingPage() === 'RESULT') {
      return searchMapiCompleted(search);
    } else {
      return fetcher.post(metaURL).json().then(shoppingCartResponse => {
        return searchMapiCompleted({
          ...search,
          ...shoppingCartResponse
        });
      }).catch(() => {
        handlerSearchMapiError();
        return Promise.reject();
      });
    }
  };
  return {
    handlerCreateMapiShoppingCart,
    handlerSearchMapiError
  };
};